module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Influencer-Video-1.d2c02414.webp";